<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title> Nicht verrechnet </ion-title>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/home/tab3" (click)="close()" [text]="originPage"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar mode="ios" class="section">
    <ion-segment [(ngModel)]="section" (ngModelChange)="refreshList($event)" mode="ios">
      <ion-segment-button value="allServices">
        <ion-label>Alle Leistungen</ion-label>
      </ion-segment-button>
      <ion-segment-button value="pastServices">
        <ion-label>Absolvierte Leistungen</ion-label>
      </ion-segment-button>
    </ion-segment>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-refresher slot="fixed" (ionRefresh)="refreshList($event)">
    <ion-refresher-content> </ion-refresher-content>
  </ion-refresher>
    <ion-list class="dark:bg-darklist p-0">
      @for (group of groupedServices; track group.services) {
        <ion-item
          button
          (click)="openNewInvoiceDialog(group)"
          detail="false"
        >
          <ion-label>
            <h2>{{ group.student.forename }} {{ group.student.surname }}</h2>
            <p> {{ group.total_amount }} CHF</p>
          </ion-label> 
          @if (group.amount_of_services > 1) {
            <ion-badge mode="ios" color="warning">{{
              group.amount_of_services
            }}</ion-badge>
            }
        </ion-item>
      }
    </ion-list>
</ion-content>

